/**
 * Analytics environment: 'development' | 'production'
 * Used for filtering events in Mixpanel/PostHog (exclude dev data from prod funnels).
 */

export type AnalyticsEnvironment = 'development' | 'production'

export function getAnalyticsEnvironment(): AnalyticsEnvironment {
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'production') {
    return 'production'
  }
  if (typeof process !== 'undefined' && process.env?.EXPO_PUBLIC_ENV === 'production') {
    return 'production'
  }
  return 'development'
}
